import React, { useEffect } from 'react';
import styles from './ApplicantsTable.module.css';
import TablePagination from '../Pagination/TablePagination';
import Loader from '../Loader/Loader';
import HappyIcon from '../../../assets/Imagess/HappyIcon.svg';
import NormalIcon from '../../../assets/Imagess/NormalIcon.svg';
import SadIcon from '../../../assets/Imagess/SadIcon.svg';
import moment from 'moment';
import {
  researchFullName,
  researchEntryTitle,
  researchEntryId,
  researchSubmittedOn,
  submissionKindLabel,
} from '../../../app/helpers/researchEntry';
import {
  RESEARCH_STATUS,
  researchStatusLabel,
} from '../../../app/helpers/researchQuery';

const UsersTable = ({
  tableHeader,
  data,
  page,
  setPage,
  setPageSize,
  pageSize,
  isLoading,
  order,
  setOrder,
  refetch,
  mode,
  setDetails,
  setMoveRight,
  /* Research registry only. Absent for every other mode, which is why each is
     optional-chained at the point of use rather than defaulted into a no-op. */
  selectedIds = [],
  onToggleSelect,
  onToggleSelectAll,
  onExportOne,
}) => {
  const rows = Array.isArray(data) ? data : (data?.items ?? []);

  /* Selection is tracked by the PAGE, not the whole result set: "select all"
     on a filtered list of 300 would otherwise silently tick records the
     operator has never seen. */
  const pageIds =
    mode === 'research' ? rows.map((r) => researchEntryId(r)).filter(Boolean) : [];
  const someOnPageSelected = pageIds.some((id) => selectedIds.includes(id));
  const allOnPageSelected =
    pageIds.length > 0 && pageIds.every((id) => selectedIds.includes(id));
  const totalItems = Array.isArray(data)
    ? data.length
    : (data?.totalCount ?? 0);
  const itemsPerPage = pageSize || data?.pageSize || 10;
  const totalPages = totalItems > 0 ? Math.ceil(totalItems / itemsPerPage) : 1;
  const handleOnClick = (e, id, id1 = '') => {
    setDetails(id);
    setMoveRight(true);
  };

  useEffect(() => {
    refetch();
  }, [order]);

  const handleOrder = (column) => {
    if (order[1] === 'asc') {
      setOrder([column, 'desc']);
    } else {
      setOrder([column, 'asc']);
    }
  };
  const formatCell = (value, key) => {
    if (value === null || value === undefined || value === '') return '-';

    const cleaned =
      typeof value === 'string' ? value.replace(/\s+/g, ' ').trim() : value;

    if (key === 'createdOn')
      return moment(cleaned).format('MMM Do YYYY, h:mm a');

    return cleaned;
  };

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <div className={styles['container']} id={mode}>
        <table className={styles['userstable-container']}>
          <thead>
            <tr>
              {/* The registry's two furniture columns. They carry no sortable
                  field, so they are not in `tableHeader` — that array is the
                  DATA columns, and the sort sends each `originalName` to the
                  API. */}
              {mode === 'research' ? (
                <th className={`${styles.firstRadius} ${styles['header-cell']} ${styles.selectCell}`}>
                  <input
                    type='checkbox'
                    checked={allOnPageSelected}
                    ref={(el) => {
                      // Indeterminate is a PROPERTY, not an attribute — it
                      // cannot be set in JSX. Some-but-not-all selected has to
                      // look different from none, or "select all" reads as
                      // already done.
                      if (el) el.indeterminate = someOnPageSelected && !allOnPageSelected;
                    }}
                    onChange={() => onToggleSelectAll?.(pageIds)}
                    aria-label='تحديد كل السجلات في هذه الصفحة'
                  />
                </th>
              ) : null}
              {tableHeader &&
                tableHeader?.map((item, index) => {
                  return (
                    <th
                      className={
                        mode === 'research'
                          ? styles['header-cell']
                          : index === 0
                            ? `${styles.firstRadius} ${styles['header-cell']}`
                            : index === tableHeader.length - 1
                              ? `${styles.lastRadius} ${styles['header-cell']}`
                              : `${styles['header-cell']} `
                      }
                      key={index}
                    >
                      {item?.name}{' '}
                      {/* {item?.sort !== false &&
                        (order[1] === "desc" ? (
                          <img
                            className={styles["pointer"]}
                            src={upArrow}
                            alt="icon"
                            onClick={() => handleOrder(item?.originalName)}
                          />
                        ) : (
                          <img
                            className={styles["pointer"]}
                            src={downArrow}
                            alt="icon"
                            onClick={() => handleOrder(item?.originalName)}
                          />
                        ))} */}
                    </th>
                  );
                })}
              {mode === 'research' ? (
                <th
                  className={`${styles.lastRadius} ${styles['header-cell']} ${styles.actionCell}`}
                >
                  <span className={styles.srOnly}>إجراءات</span>
                </th>
              ) : null}
            </tr>
          </thead>
          <tbody>
            {mode === 'applicants' &&
              data?.items?.map((item) => (
                <tr
                  key={item.applicantId}
                  onClick={(e) => {
                    handleOnClick(e, item.applicantId);
                  }}
                >
                  <td
                    className={`${styles['firstColumn']} ${styles.firstRadius}`}
                  >
                    {item.fullName_EN}
                  </td>
                  <td>{item.fullName_AR}</td>
                  <td>{item.email}</td>
                  <td>{item.mobile}</td>
                  <td className={`${styles.lastRadius}`}>
                    {item.applicationStart_Display}
                  </td>
                </tr>
              ))}

            {mode === 'leads' &&
              data?.items?.map((item) => (
                <tr
                  key={item.showingInterestId}
                  onClick={(e) => {
                    handleOnClick(e, item.showingInterestId);
                  }}
                >
                  <td
                    className={`${styles['firstColumn']} ${styles.firstRadius}`}
                  >
                    {item.firstName}
                  </td>
                  <td>{item.lastName}</td>
                  <td>{item.email}</td>
                  <td>{item.phoneNumber}</td>
                  <td className={`${styles.lastRadius}`}>{item.degreeType}</td>
                </tr>
              ))}

            {mode === 'scholarship' &&
              data?.items?.map((item) => (
                <tr
                  key={item.scholarshipApplicationId}
                  onClick={(e) => {
                    handleOnClick(e, item.scholarshipApplicationId);
                  }}
                >
                  <td
                    className={`${styles['firstColumn']} ${styles.firstRadius}`}
                  >
                    {item.firstName}
                  </td>
                  <td>{item.lastName}</td>
                  <td>{item.email}</td>
                  <td>{item.phoneNumber}</td>
                  <td>{item.degreeType}</td>
                  <td className={`${styles.lastRadius}`}>
                    {moment(item.createdOn).format('MMM Do YYYY, h:mm a')}
                  </td>
                </tr>
              ))}

            {mode === 'facility' &&
              rows.map((item, rowIndex) => (
                <tr
                  key={item.facilityId || rowIndex}
                  onClick={(e) => handleOnClick(e, item.facilityId)}
                >
                  {tableHeader.map((col, colIndex) => {
                    const isFirst = colIndex === 0;
                    const isLast = colIndex === tableHeader.length - 1;

                    return (
                      <td
                        key={col.originalName}
                        className={
                          isFirst
                            ? `${styles['firstColumn']} ${styles.firstRadius}`
                            : isLast
                              ? `${styles.lastRadius}`
                              : undefined
                        }
                      >
                        {formatCell(item?.[col.originalName], col.originalName)}
                      </td>
                    );
                  })}
                </tr>
              ))}

            {mode === 'newsletterSubscription' &&
              data?.items?.map((item) => (
                <tr key={item.newsletterSubscriptionId}>
                  <td
                    className={`${styles['firstColumn']} ${styles.firstRadius}`}
                  >
                    {item.email}
                  </td>
                  <td className={`${styles.lastRadius}`}>
                    {moment(item.subscribedOn).format('MMM Do YYYY, h:mm a')}
                  </td>
                </tr>
              ))}

            {/* The research inbox became a REGISTRY in October 2026: its
                entries are research already published, or studies. The two
                name columns collapsed into one, and the three facts an
                operator needs to triage an entry — what kind it is, its title,
                and when it was published — were added.
                See DPA-FE/docs/researchesPlanning/. */}
            {mode === 'research' &&
              rows.map((item) => {
                const id = researchEntryId(item);
                const submitted = researchSubmittedOn(item);
                const status = String(item.status || '').toLowerCase();
                const picked = selectedIds.includes(id);
                return (
                  <tr
                    key={id}
                    onClick={(e) => handleOnClick(e, id)}
                    /* An unopened submission is the one an operator is hunting
                       for, so it is the one the row emphasises. */
                    className={
                      status === RESEARCH_STATUS.NEW ? styles.unread : undefined
                    }
                  >
                    {/* The tick and the row action must NOT open the record:
                        the whole row is a link to the detail screen, and a
                        checkbox that navigated away would make selecting more
                        than one impossible. */}
                    <td
                      className={`${styles.selectCell} ${styles.firstRadius}`}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <input
                        type='checkbox'
                        checked={picked}
                        onChange={() => onToggleSelect?.(id)}
                        aria-label={`تحديد ${researchFullName(item)}`}
                      />
                    </td>
                    <td className={`${styles['firstColumn']}`}>
                      {researchFullName(item)}
                    </td>
                    <td>
                      <span
                        className={`${styles.status} ${
                          styles[`status_${status}`] || ''
                        }`}
                      >
                        {researchStatusLabel(item.status)}
                      </span>
                    </td>
                    <td>{submissionKindLabel(item.submissionKind)}</td>
                    <td>{researchEntryTitle(item)}</td>
                    {/* A study has no publication year, and the API sends null
                        rather than omitting it — so this is a dash by design,
                        not missing data. */}
                    <td>{item.publicationYear || '-'}</td>
                    <td>{item.email}</td>
                    <td>
                      {submitted
                        ? moment(submitted).format('MMM Do YYYY, h:mm a')
                        : '-'}
                    </td>
                    <td
                      className={`${styles.lastRadius} ${styles.actionCell}`}
                      onClick={(e) => e.stopPropagation()}
                    >
                      <button
                        type='button'
                        className={styles.rowAction}
                        onClick={() => onExportOne?.(id)}
                        title='تصدير هذا السجل'
                        aria-label={`تصدير سجل ${researchFullName(item)}`}
                      >
                        ⭳
                      </button>
                    </td>
                  </tr>
                );
              })}

            {mode === 'quizzes' &&
              data?.map((item) => (
                <tr
                  key={item.quizId}
                  onClick={(e) => {
                    handleOnClick(e, item.quizId);
                  }}
                >
                  <td
                    className={`${styles['firstColumn']} ${styles.firstRadius}`}
                  >
                    {item.userName}
                  </td>
                  <td>{item.userEmail}</td>
                  <td>
                    {item?.degreeSuggested?.degreeType == 0
                      ? 'Bachelor'
                      : item?.degreeSuggested?.degreeType == 1
                        ? 'Master'
                        : 'PHD'}
                  </td>
                  <td>{item?.degreeSuggested?.degreeNameEn}</td>
                  <td className={`${styles.lastRadius}`}>
                    {moment(item.createdOn).format('MMM Do YYYY, h:mm a')}
                  </td>
                </tr>
              ))}

            {mode === 'happinessMeter' &&
              data?.map((item, index) => (
                <tr key={item.applicantId}>
                  <td
                    className={`${styles['firstColumn']} ${styles.firstRadius}`}
                  >
                    {' '}
                    {item.happyMetter == 3 && (
                      <img
                        src={HappyIcon}
                        className={styles['HappinessIcon']}
                        alt={''}
                      />
                    )}
                    {item.happyMetter == 2 && (
                      <img
                        src={NormalIcon}
                        className={styles['HappinessIcon']}
                        alt={''}
                      />
                    )}
                    {item.happyMetter == 1 && (
                      <img
                        src={SadIcon}
                        className={styles['HappinessIcon']}
                        alt={''}
                      />
                    )}
                  </td>
                  <td className={`${styles.lastRadius}`}>
                    {moment(item.recordedDate).format('MMM Do YYYY, h:mm a')}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <TablePagination
        totalPages={totalPages}
        page={page}
        setPage={setPage}
        itemsPerPage={pageSize}
        setPageSize={setPageSize}
      />
    </>
  );
};

export default UsersTable;
